import log from '$$log';
import commonData from './commonData';
import projectsData from './projectsData';
import customDaysData from './customDaysData';
import resourcesData from './resourcesData';
import tasksData from './tasksData';
import workloadData from './workloadData';
import columnsData from './columnsData';
import timeTrackingData from './timeTrackingData';
import copyPasteData from './copyPasteData';

const GanttDataApi = {
  init(instance, ganttData = null) {
    instance.ganttDataApi = {};

    let t = log.time('ganttCreateInstance.dataApi.commonData');
    commonData(instance, ganttData); // adds methods to work with common store, masschange store, filter store and etc.
    t.end();

    t = log.time('ganttCreateInstance.dataApi.projectsData');
    projectsData(instance, ganttData); // adds methods to work with projects, ganttview and multiview models
    t.end();

    t = log.time('ganttCreateInstance.dataApi.customDaysData');
    customDaysData(instance, ganttData); // adds methods to work with custom days model
    t.end();

    t = log.time('ganttCreateInstance.dataApi.resourcesData');
    resourcesData(instance, ganttData); // adds methods to work with resources store
    t.end();

    t = log.time('ganttCreateInstance.dataApi.tasksData');
    tasksData(instance, ganttData); // adds methods to work with tasks store
    t.end();

    t = log.time('ganttCreateInstance.dataApi.workloadData');
    workloadData(instance, ganttData); // adds methods to work with workload
    t.end();

    t = log.time('ganttCreateInstance.dataApi.columnsData');
    columnsData(instance, ganttData); // adds methods to work with columns store
    t.end();

    t = log.time('ganttCreateInstance.dataApi.timeTrackingData');
    timeTrackingData(instance, ganttData); // adds methods to work with time tracking model
    t.end();

    t = log.time('ganttCreateInstance.dataApi.copyPasteData');
    copyPasteData(instance, ganttData); // adds methods to work with time copypaste store
    t.end();
  },
};

export default GanttDataApi;
